export enum CmsPropertyKeys {
    ResultlistDisturberPosition = 'meinestadt/types#resultlist_disturber_position',
    ResultlistDisturberBreakpoint = 'meinestadt/layout#breakpoint',
    HasStickyFilter = 'meinestadt/types#hasStickyFilter',
    HasStickyFilterSecondIteration = 'meinestadt/types#hasStickyFilterSecondIteration',
}
